/* eslint-disable no-nested-ternary */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { ActionIcon, Group, Skeleton, Text, Tooltip, useMantineTheme } from '@mantine/core';
import { FC, useEffect, useState } from 'react';
import { IconEye, IconX } from '@tabler/icons';
import { closeAllModals } from '@mantine/modals';
import { PortalS, ResourceStatus } from '../../../Service/PortalS';
import { fetchFormSubmissionOfResource } from '../../../Service/restapi/shareService';
import { FormSubmissionDto } from '../../../Types/ShareT';
import { openDeleteConfirmModal } from '../../../Atoms/DeleteConfirmModal';
import { openFormSubmissionModal } from '../../../Organismns/Share/FormSubmissionModal';
import { useEventScope } from '../../../Service/hooks/useEventScope';

const DocumentResourceBadge: FC<{
  id: string;
  shortVersion?: boolean;
  entityType: string;
  onDelete: () => Promise<boolean>;
  setSigned?: (val: boolean) => void;
}> = ({ id, shortVersion, entityType, onDelete, setSigned }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const { eventId } = useEventScope();
  const [formSubmission, setFormSubmission] = useState<FormSubmissionDto>();
  const resourceStatus: ResourceStatus = !formSubmission
    ? 'PUBLISHED'
    : formSubmission && formSubmission.lastSubmitted
    ? 'CONFIRMED'
    : 'SEEN';

  const { colorScheme } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  useEffect(() => {
    fetchFormSubmissionOfResource(id)
      .then((resp) => {
        if (resp.ok) {
          resp.json().then(setFormSubmission);
        }
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (setSigned && formSubmission && formSubmission.lastSubmitted) {
      setSigned(true);
    }
  }, [formSubmission, setSigned]);

  if (shortVersion) {
    return (
      <div>
        {loading ? (
          <Skeleton circle width={10} height={10} />
        ) : (
          <ResourceStatusIcon status={resourceStatus} entityType={entityType} />
        )}
      </div>
    );
  }

  const deleteHandler = () => {
    openDeleteConfirmModal({
      title: 'Wirklich löschen?',
      description: 'Möchten Sie die Freigabe des Dokuments wirklich aufheben?',
      onConfirm: onDelete,
    });
  };

  const showAnswers = () => {
    if (formSubmission) {
      openFormSubmissionModal({
        formSubmission,
        closeModal: closeAllModals,
        eventId: eventId ?? '',
      });
    }
  };

  return (
    <Group spacing={5}>
      <Group
        spacing={0}
        sx={(theme) => ({
          textTransform: 'none',
          display: 'flex',
          backgroundColor: darkMode ? theme.colors.dark[5] : theme.colors.gray[1],
          borderRadius: 10,
        })}
      >
        {loading ? (
          <Skeleton mr={8} ml={8} circle width={8} height={8} />
        ) : (
          <ResourceStatusIcon status={resourceStatus} entityType={entityType} />
        )}
        <Text size={10} weight="bolder">
          Freigegeben
        </Text>
        <ActionIcon size="xs" onClick={deleteHandler}>
          <IconX size={12} />
        </ActionIcon>
      </Group>
      {entityType === 'questionnaires' && resourceStatus === 'CONFIRMED' && (
        <Tooltip label="Kundeneingaben ansehen">
          <ActionIcon size="xs" onClick={showAnswers}>
            <IconEye />
          </ActionIcon>
        </Tooltip>
      )}
    </Group>
  );
};

export const ResourceStatusIcon: FC<{ status: ResourceStatus; entityType: string }> = ({ status, entityType }) => (
  <Tooltip
    withArrow
    position="left-start"
    transition="pop"
    label={PortalS.getResourceTooltipMessage(entityType, status)}
  >
    <div
      style={{
        width: 8,
        height: 8,
        marginLeft: 8,
        marginRight: 8,
        borderRadius: '50%',
        backgroundColor: PortalS.getResouceStatusColor(status),
        boxShadow: `0px 0px 8px ${PortalS.getResouceStatusColor(status)}`,
      }}
    />
  </Tooltip>
);

export default DocumentResourceBadge;
